import React from "react";
import {
    Card,
    CardDemo,
    CardInfo,
    TechList,
    TechIcon,
    Links,
    Live,
} from "./style";
import getIcon from "util/getIcon";

export default function WorkCard({ details }) {
    return (
        <Card>
            <CardDemo
                href={details.url}
                target="_blank"
                rel="noreferrer noopener"
            >
                <img src={details.img} alt={`${details.demo} demo`} loading="lazy"/>
            </CardDemo>
            <CardInfo>
                <h3>{details.name}</h3>
                <p>{details.desc}</p>
                <TechList>
                    <h3>Tech Used:</h3>
                    {details.tech.map((item, i) => (
                        <TechIcon key={i}>
                            <svg>
                                <use href={getIcon(item)} />
                            </svg>
                        </TechIcon>
                    ))}
                </TechList>
                <Links>
                    <Live
                        href={details.url}
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        <svg>
                            <use href={getIcon("sphere")} />
                        </svg>
                        Demo
                    </Live>
                    <Live
                        href={details.repo}
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        <svg>
                            <use href={getIcon("github1")} />
                        </svg>
                        Repo
                    </Live>
                </Links>
            </CardInfo>
        </Card>
    );
}
